'use client';

import { c as _c } from "react/compiler-runtime";
import { Tabs as TabsPrimitive } from '@base-ui/react/tabs';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '@repo/ui/lib/utils';
function Tabs(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      orientation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const orientation = t1 === undefined ? "horizontal" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("group/tabs flex gap-2 data-horizontal:flex-col", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== orientation || $[7] !== props || $[8] !== t2) {
    t3 = <TabsPrimitive.Root className={t2} data-orientation={orientation} data-slot="tabs" orientation={orientation} {...props} data-sentry-element="TabsPrimitive.Root" data-sentry-component="Tabs" data-sentry-source-file="tabs.tsx" />;
    $[6] = orientation;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
const tabsListVariants = cva('group/tabs-list inline-flex w-fit items-center justify-center rounded-lg p-[3px] text-muted-foreground group-data-horizontal/tabs:h-8 group-data-vertical/tabs:h-fit group-data-vertical/tabs:flex-col data-[variant=line]:rounded-none', {
  defaultVariants: {
    variant: 'default'
  },
  variants: {
    variant: {
      default: 'bg-muted',
      line: 'gap-1 bg-transparent'
    }
  }
});
function TabsContent(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex-1 text-sm outline-none", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <TabsPrimitive.Panel className={t1} data-slot="tabs-content" {...props} data-sentry-element="TabsPrimitive.Panel" data-sentry-component="TabsContent" data-sentry-source-file="tabs.tsx" />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function TabsList(t0) {
  const $ = _c(11);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      variant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const variant = t1 === undefined ? "default" : t1;
  let t2;
  if ($[4] !== className || $[5] !== variant) {
    t2 = cn(tabsListVariants({
      variant
    }), className);
    $[4] = className;
    $[5] = variant;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== t2 || $[9] !== variant) {
    t3 = <TabsPrimitive.List className={t2} data-slot="tabs-list" data-variant={variant} {...props} data-sentry-element="TabsPrimitive.List" data-sentry-component="TabsList" data-sentry-source-file="tabs.tsx" />;
    $[7] = props;
    $[8] = t2;
    $[9] = variant;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function TabsTrigger(t0) {
  const $ = _c(17);
  let children;
  let className;
  let nativeButton;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      asChild: t1,
      children,
      className,
      nativeButton,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = nativeButton;
    $[4] = props;
    $[5] = t1;
  } else {
    children = $[1];
    className = $[2];
    nativeButton = $[3];
    props = $[4];
    t1 = $[5];
  }
  const asChild = t1 === undefined ? false : t1;
  let t2;
  if ($[6] !== className) {
    t2 = cn("relative inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-1.5 py-0.5 text-sm font-medium whitespace-nowrap text-foreground/60 transition-all group-data-vertical/tabs:w-full group-data-vertical/tabs:justify-start hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1 focus-visible:outline-ring disabled:pointer-events-none disabled:opacity-50 has-data-[icon=inline-end]:pr-1 has-data-[icon=inline-start]:pl-1 aria-disabled:pointer-events-none aria-disabled:opacity-50 group-data-[variant=default]/tabs-list:data-active:shadow-sm group-data-[variant=line]/tabs-list:data-active:shadow-none dark:text-muted-foreground dark:hover:text-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", "group-data-[variant=line]/tabs-list:bg-transparent group-data-[variant=line]/tabs-list:data-active:bg-transparent dark:group-data-[variant=line]/tabs-list:data-active:border-transparent dark:group-data-[variant=line]/tabs-list:data-active:bg-transparent", "data-active:bg-background data-active:text-foreground dark:data-active:border-input dark:data-active:bg-input/30 dark:data-active:text-foreground", "after:absolute after:bg-foreground after:opacity-0 after:transition-opacity group-data-horizontal/tabs:after:inset-x-0 group-data-horizontal/tabs:after:bottom-[-5px] group-data-horizontal/tabs:after:h-0.5 group-data-vertical/tabs:after:inset-y-0 group-data-vertical/tabs:after:-right-1 group-data-vertical/tabs:after:w-0.5 group-data-[variant=line]/tabs-list:data-active:after:opacity-100", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = nativeButton ?? (asChild ? false : undefined);
  let t4;
  if ($[8] !== asChild || $[9] !== children) {
    t4 = (renderProps, state) => {
      const dataState = state.active ? "active" : "inactive";
      const {
        children: _children,
        ...rest
      } = renderProps;
      if (asChild && React.isValidElement(children)) {
        return React.cloneElement(children, {
          ...rest,
          "data-state": dataState
        });
      }
      return <button {...rest} data-state={dataState}>{children}</button>;
    };
    $[8] = asChild;
    $[9] = children;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== children || $[12] !== props || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <TabsPrimitive.Tab className={t2} data-slot="tabs-trigger" nativeButton={t3} render={t4} {...props} data-sentry-element="TabsPrimitive.Tab" data-sentry-component="TabsTrigger" data-sentry-source-file="tabs.tsx">{children}</TabsPrimitive.Tab>;
    $[11] = children;
    $[12] = props;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
export { Tabs, TabsContent, TabsList, tabsListVariants, TabsTrigger };